import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { FixedBtns, Typography } from '@quikr/ui';
import { convertPriceToIndFormat } from '@quikr/ui/src/helpers/common';
import { Check } from '@quikr/ui/src/icons';

const JobsSticky = styled.div`
  position: sticky;
  height: 0;
  top: 132px;
  z-index: 2;
  background-color: #f8f8f8;
  transform: translateY(-100px);
  transition: transform 0.3s ease;
  ${({ active }) =>
  active &&
    css`
      height: auto;
      padding: 12px 15px;
      transform: translateY(0);
    `}
`;

const JobsStickyDesc = styled.div`
  min-width: 20%;
  margin-right: 10px;
`;

const JobsStickyBtns = styled.div`
  flex-grow: 1;
  justify-content: flex-end;
`;

const VapTitle = styled(Typography)`
  line-height: 20px;
`;

const VapSalary = styled.div`
  color: ${props => props.theme.colors.Primary};
  margin-top: 2px;
  line-height: 22px;
`;

const ApplySuccess = styled.div`
  color: ${({ theme }) => theme.colors.Secondary};
  margin-right: 14px;
  span {
    flex: 0 0 23px;
    height: 23px;
    border-radius: 50%;
    border: 2px solid ${({ theme }) => theme.colors.Secondary};
    margin-right: 8px;
  }
  svg {
    fill: ${({ theme }) => theme.colors.Secondary};
    width: 16px;
  }
`;

const FixedBtnWrapper = styled(FixedBtns)`
  display: flex;
  button {
    white-space: nowrap;
    padding: 0 12px;
  }
`;

const StickyHeader = props => {
  const { actions, actionClick, title, minsalary, maxsalary, active, applySuccess, fireGa } = props;

  return (
    <JobsSticky className="dFA" active={active}>
      <JobsStickyDesc>
        <VapTitle className="Ell" tagName="div" modifiers="bold">
          {title}
        </VapTitle>
        <VapSalary className="fwM">
          Salary : <span>₹</span>
          {convertPriceToIndFormat(minsalary)}
          &nbsp;-&nbsp;
          <span>₹</span>
          {convertPriceToIndFormat(maxsalary)}
        </VapSalary>
      </JobsStickyDesc>
      <JobsStickyBtns className="dF">
        {applySuccess && (
          <ApplySuccess className="dFA">
            <span className="dFA jcC">
              <Check />
            </span>{' '}
            Applied
          </ApplySuccess>
        )}
        <FixedBtnWrapper
          type="top_sticky"
          actions={actions}
          actionClick={actionClick}
          size="sm"
          fireGa={fireGa}
        />
      </JobsStickyBtns>
    </JobsSticky>
  );
};

StickyHeader.propTypes = {
  actions: PropTypes.array,
  title: PropTypes.string,
  actionClick: PropTypes.func,
  minsalary: PropTypes.string,
  maxsalary: PropTypes.string,
  active: PropTypes.bool,
  applySuccess: PropTypes.bool,
  fireGa: PropTypes.func
};

export default StickyHeader;
